import React, { useEffect, useState, useRef } from "react";
import './SalesMarketing.css';

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';


import ResumeMail from "./ResumeMail";
import JobSearch from "./JobSearch";


function SalesMarketing() {
  const [value, setValue] = useState(0);

  const handleChange1 = (event, newValue) => {
    setValue(newValue);
  };
 
 

 


  function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };  

  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange1} aria-label="basic tabs example">
          <Tab label="Employer" {...a11yProps(0)} />
          <Tab label="Job Seeker" {...a11yProps(1)} />
         
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
     <ResumeMail />
      </TabPanel>
      <TabPanel value={value} index={1}>
      <JobSearch />
      </TabPanel>
  
    </Box>
   
  )
}

export default SalesMarketing